import actionTypes from '../constants/action-types';

const categories = (state = [], action) => {
  if (action.type !== actionTypes.SET_CATEGORIES) return state;
  return action.payload.categories;
};

export default categories;
